// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1El6U","text":"styles_text__YTN_6","big":"styles_big__tAQ5H"};